import { v2Host } from '@/config/host'
import { getApiPath } from '@/common/api-proxy.js'
import { getToken } from '@/utils/auth.js'

/**
 * downloadWithIframe
 * @param {string} url
 * @param {string} [name]
 * @param {boolean} [useCommonDownload]，是否使用通用下载
 * @param {boolean} [isZip]，是否下载 zip 包
 */
export function downloadWithIframe(url, name, useCommonDownload, isZip, s3) {
  return new Promise((resolve, reject) => {
    if (!url) {
      throw new Error('URL 是必传参数')
    }

    const downloadIframe = document.getElementById(
      `J-download-file-iframe-${url}`,
    )

    if (downloadIframe) downloadIframe.remove()

    const ifr = document.createElement('iframe')
    ifr.onload = function () {
      // 无法触发
      // https://stackoverflow.com/questions/6126619/which-js-event-is-fired-when-chrome-gets-the-download-file/6245998#6245998
      ifr.remove()
      resolve()
    }
    ifr.onerror = function () {
      // 无法触发
      ifr.remove()
      reject()
    }

    if (useCommonDownload) {
      ifr.src = url
    } else {
      // 如果是下载 zip 包文件，则通过 urls 进行传参
      if (isZip) {
        ifr.src = `${v2Host}${getApiPath(
          '/common/download',
        )}?urls=${url}&_token=${getToken()}`
      } else {
        ifr.src = `${v2Host}${getApiPath(
          '/common/download',
        )}?url=${url}&_token=${getToken()}`
      }
    }
    if (s3) {
      ifr.src = `${v2Host}${getApiPath('/common/download')}?s3=${s3}&key=${url}`
    }
    if (name) ifr.src += `&filename=${name}`
    ifr.style.display = 'none'
    ifr.setAttribute('id', `J-download-file-iframe-${url}`)
    document.body.appendChild(ifr)
  })
}

/**
 * downloadWithNewWindow
 * @param url {string}
 * @param name {string}
 */
export function downloadWithNewWindow(url, name) {
  url = `${url}&_token=${getToken()}`
  if (name) url += `&filename=${name}`
  window.open(url, '_blank')
}
/**
 * downloadLoadDocument 本地下载文件
 * @param href {string} 本地文件的路径
 * @param name {string} 文件名字
 * @param type {string} 文件类型
 */
export function downloadLoadDocument(href, name, type) {
  const loadDocument = document.createElement('a')
  loadDocument.href = href
  loadDocument.download = name + '.' + type
  loadDocument.style.display = 'none'
  document.body.appendChild(loadDocument)
  loadDocument.click()
  loadDocument.remove()
}
